import { useLocation, useNavigate } from "react-router-dom";
import {useState } from "react";
import { toast } from "react-toastify";
import BackArrowIcon from "../../components/Icons/BackArrowIcon";
import EmployeeBasicDetails from "../HRM/HrmSettings/EmployeeOnBoard/OnBoardComponents/EmployeeBasicDetails";
import EmployeeAdvanceDetails from "../HRM/HrmSettings/EmployeeOnBoard/OnBoardComponents/EmployeeAdvanceDetails";
import EmployeeAddressDetails from "../HRM/HrmSettings/EmployeeOnBoard/OnBoardComponents/EmployeeAddressDetails";
import EmployeeBankDetails from "../HRM/HrmSettings/EmployeeOnBoard/OnBoardComponents/EmployeeBankDetails";
import EmployeeNomineeDetails from "../HRM/HrmSettings/EmployeeOnBoard/OnBoardComponents/EmployeeNomineeDetails";
import EmployeePreviousWork from "../HRM/HrmSettings/EmployeeOnBoard/OnBoardComponents/EmployeePreviousWork";
import EmployeeDocuments from "../HRM/HrmSettings/EmployeeOnBoard/OnBoardComponents/EmployeeDocuments";
import {
    Nav,
    NavItem,
    NavLink,
    Spinner,
    TabContent,
    Fade,
    TabPane,
  } from "reactstrap";

export default function UpdateProfile() {
  const navigate = useNavigate();
  const location = useLocation();
  const [pageStates, setPageStates] = useState({
    activeTab: 1
  });


  const toggleTab = (tab) => {
      setPageStates((prev) => ({ ...prev, activeTab: tab }));
  };

  return (
    <>
      <>
        <div className="content container-fluid">
          <div className="content-head mb-5 d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center justify-content-start gap-4">
              <button
                role="button"
                className="btn back-arrow"
                onClick={() => navigate(-1)}
              >
                <BackArrowIcon />
              </button>
              <h1 className="mb-0">
                Update Profile
              </h1>
            </div>
          </div>

          <div className="card mb-4">
            <div className="card-body">
              <div className="wizard-tabs">
                <Nav tabs className="nav nav-pills">
                  <NavItem className="nav-item">
                    <NavLink
                      className={
                        pageStates?.activeTab === 1 ? "border-0 p-2 active" : ""
                      }
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleTab(1)}
                    >
                      <h5>Basic Details</h5>
                    </NavLink>
                  </NavItem>
                  <li className="nav-item">
                    <div className="border-top-item" />
                  </li>
                  <NavItem className="nav-item">
                    <NavLink
                      className={
                        pageStates?.activeTab === 2 ? "border-0 p-2 active" : ""
                      }
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleTab(2)}
                    >
                      <h5>Advance Details</h5>
                    </NavLink>
                  </NavItem>
                  <li className="nav-item">
                    <div className="border-top-item" />
                  </li>
                  <NavItem className="nav-item">
                    <NavLink
                      className={
                        pageStates?.activeTab === 3 ? "border-0 p-2 active" : ""
                      }
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleTab(3)}
                    >
                      <h5>Address</h5>
                    </NavLink>
                  </NavItem>
                  <li className="nav-item">
                    <div className="border-top-item" />
                  </li>
                  <NavItem className="nav-item">
                    <NavLink
                      className={
                        pageStates?.activeTab === 4 ? "border-0 p-2 active" : ""
                      }
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleTab(4)}
                    >
                      <h5>Bank Details</h5>
                    </NavLink>
                  </NavItem>
                  <li className="nav-item">
                    <div className="border-top-item" />
                  </li>
                  <NavItem className="nav-item">
                    <NavLink
                      className={
                        pageStates?.activeTab === 5 ? "border-0 p-2 active" : ""
                      }
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleTab(5)}
                    >
                      <h5>Nominee Details</h5>
                    </NavLink>
                  </NavItem>
                  <li className="nav-item">
                    <div className="border-top-item" />
                  </li>
                  <NavItem className="nav-item">
                    <NavLink
                      className={
                        pageStates?.activeTab === 6 ? "border-0 p-2 active" : ""
                      }
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleTab(6)}
                    >
                      <h5>Previous Work</h5>
                    </NavLink>
                  </NavItem>
                  <li className="nav-item">
                    <div className="border-top-item" />
                  </li>
                  <NavItem className="nav-item">
                    <NavLink
                      className={
                        pageStates?.activeTab === 7 ? "border-0 p-2 active" : ""
                      }
                      style={{ cursor: "pointer" }}
                      onClick={() => toggleTab(7)}
                    >
                      <h5>Documents</h5>
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <TabContent activeTab={pageStates?.activeTab}>
                <TabPane tabId={1}>
                  <Fade in={pageStates?.activeTab === 1} timeout={200}>
                    <EmployeeBasicDetails
                      setPageStates={setPageStates}
                      locationData={location?.state?.data}
                    />
                  </Fade>
                </TabPane>
                <TabPane tabId={2}>
                  <Fade in={pageStates?.activeTab === 2} timeout={200}>
                    <EmployeeAdvanceDetails
                      locationData={location?.state?.data}
                      pageStatesMain={pageStates}
                      setPageStatesMain={setPageStates}
                    />
                  </Fade>
                </TabPane>
                <TabPane tabId={3}>
                  <Fade in={pageStates?.activeTab === 3} timeout={200}>
                    <EmployeeAddressDetails
                      locationData={location?.state?.data}
                      pageStatesMain={pageStates}
                      setPageStatesMain={setPageStates}
                    />
                  </Fade>
                </TabPane>
                <TabPane tabId={4}>
                  <Fade in={pageStates?.activeTab === 4} timeout={200}>
                    <EmployeeBankDetails
                      locationData={location?.state?.data}
                      pageStatesMain={pageStates}
                      setPageStatesMain={setPageStates}
                    />
                  </Fade>
                </TabPane>
                <TabPane tabId={5}>
                  <Fade in={pageStates?.activeTab === 5} timeout={200}>
                    <EmployeeNomineeDetails
                      locationData={location?.state?.data}
                      pageStatesMain={pageStates}
                      setPageStatesMain={setPageStates}
                    />
                  </Fade>
                </TabPane>
                <TabPane tabId={6}>
                  <Fade in={pageStates?.activeTab === 6} timeout={200}>
                    <EmployeePreviousWork
                      locationData={location?.state?.data}
                      pageStatesMain={pageStates}
                      setPageStatesMain={setPageStates}
                    />
                  </Fade>
                </TabPane>
                <TabPane tabId={7}>
                  <Fade in={pageStates?.activeTab === 7} timeout={200}>
                    <EmployeeDocuments
                      locationData={location?.state?.data}
                      pageStatesMain={pageStates}
                      setPageStatesMain={setPageStates}
                      redirectToProfile={true}
                    />
                  </Fade>
                </TabPane>
              </TabContent>
            </div>
          </div>
        </div>
      </>
    </>
  );
}
